import { getToken, setToken, setSidkey } from "./auth.js";
import axios from "axios";
import {Message, MessageBox} from "element-ui";
import Configs from "@/configs";
const service = axios.create({
  baseURL: Configs.businessBaseUrl || 'https://estatea.zyzhkjbj.com/prod-api/estate',//物业接口
  timeout: 60000, // request timeout
});
export function makeid(num) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < num; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}
// request interceptor
service.interceptors.request.use(
  (config) => {
    let token = getToken();
    // if ((token === undefined || token === '')) {
    //     window.location.href = '/login'
    // }
    config.headers.Authorization = "Bearer " + token;
    // const sid = getSidkey()
    // if (sid !== '' && sid !== undefined && sid !== 'undefined') {
    //     config.headers.__sid = sid
    //     config.headers.__ajax = 'json'
    // }
    //  else {
    //     window.location.href = '/login'
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.request.responseType === "blob") {
      return response;
    }
    if (res.code === 10001) {
      setSidkey("");
      setToken("");
      // if (response.config.baseURL !== "jd/") {
      //   window.location.href = "/login";
      // }

      //Message.error(res.message)
      return false;
    }
    if (res.code !== 200) {
      Message.error("登录失效");
      if (res.code === 303 || res.code === 500 || res.code===401) {
          setSidkey("");
          setToken("");
          let fullUrl = window.location.href
          if (fullUrl.indexOf('/big?projectId=') > 0) {
            MessageBox('登录已过期！请新建浏览器窗口登录以防数据丢失！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              window.open('/login')
            })
          } else if (fullUrl.indexOf('/login') < 0) {
            window.location.href = '/login?redirect=' + encodeURIComponent(fullUrl)
          }
          return
      }
      return res;
    }

    if (response.headers.token !== undefined && response.headers.token !== "") {
      setSidkey(response.headers.token);
      setToken(response.headers.token);
    }
    return res;
  },
  (error) => {
    Message.error("请求出错！" + (error.response ? error.response.status : '网络异常'));
    return { code: error.response ? error.response.status : -1, msg: error.response ? error.response.data : (error.message || '网络请求异常') };
  }
);

export default service;
